/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Directory_Ads_Week_OfInputs */

const en_directory_ads_week_of = /** @type {(inputs: Directory_Ads_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week of ${i?.date}`)
};

const zh_directory_ads_week_of = /** @type {(inputs: Directory_Ads_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} 当周`)
};

/**
* | output |
* | --- |
* | "Week of {date}" |
*
* @param {Directory_Ads_Week_OfInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_week_of = /** @type {((inputs: Directory_Ads_Week_OfInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Week_OfInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_week_of(inputs)
	return zh_directory_ads_week_of(inputs)
});
export { directory_ads_week_of as "directory.ads.week_of" }